import type { InterventionGroupDto, TreatmentPlanDto } from '../../api/generated';
import { flattenGroups } from '../../utils/ganttUtils';

// The scopes a patient assignment/removal can apply to:
// - 'plan'    → every intervention group in the treatment plan
// - 'onwards' → the selected group and all later groups
// - 'group'   → only the selected group
export type AffectedGroupsChoice = 'group' | 'onwards' | 'plan';

// The scope pre-selected when the picker first opens.
export const DEFAULT_AFFECTED_GROUPS_CHOICE: AffectedGroupsChoice = 'plan';

export function computeAffectedGroupIds(
  plan: TreatmentPlanDto,
  selectedGroup: InterventionGroupDto,
  choice: AffectedGroupsChoice
): string[] {
  if (!selectedGroup.id) return [];
  if (choice === 'group') return [selectedGroup.id];

  const flat = flattenGroups(plan);
  if (choice === 'plan') {
    return flat.map((g) => g.id ?? '').filter((id) => id !== '');
  }

  const selected = flat.find((g) => g.id === selectedGroup.id);
  if (!selected) return [];
  return flat
    .filter(
      (g) =>
        g.weekNumber > selected.weekNumber ||
        (g.weekNumber === selected.weekNumber && (g.order ?? 0) >= (selected.order ?? 0))
    )
    .map((g) => g.id ?? '')
    .filter((id) => id !== '');
}
